import QueryToolbar from "@/src/common/components/Search/QueryToolbar"
import Search from "@/src/sb/components/icon/Search"
import SearchFunnelIcon from "@/src/sb/components/icon/SearchFunnelIcon"
import classNames from "classnames"
import React, { ChangeEvent, useState } from "react"

type SearchInputProps = {
  placeholder?: string
  className?: string
  onChange?: (data: ChangeEvent<HTMLInputElement>) => void
  value?: string
  onClick?: () => void
  readOnly?: boolean
  collapsed?: boolean
  cursorBehavior?: "default" | "pointer" | "not-allowed"
  ref?: React.Ref<HTMLInputElement>
  isSearchPage?: boolean
  onFilterToggle?: (e: React.MouseEvent<HTMLButtonElement>) => void
  onFocus?: () => void
  onSubmit?: (query?: string) => void
  onNavigateToAi?: (query?: string) => void
}

const SearchInputV3 = React.forwardRef<HTMLInputElement, SearchInputProps>(
  (
    {
      placeholder,
      className,
      onChange,
      value,
      onClick,
      readOnly,
      collapsed = false,
      cursorBehavior,
      isSearchPage = false,
      onFilterToggle,
      onFocus,
      onSubmit,
      onNavigateToAi
    }: SearchInputProps,
    ref
  ) => {
    const [toolbarAiMode, setToolbarAiMode] = useState<boolean>(false)

    const handleToolbarSubmit = () => {
      if (toolbarAiMode) return
      onSubmit?.(value)
    }

    const handleToolbarNavigateToAi = () => {
      onNavigateToAi?.(value)
    }

    if (collapsed) {
      return (
        <button
          onClick={onClick}
          className={classNames(
            "flex items-center justify-center p-2",
            className
          )}
        >
          <Search size={16} />
        </button>
      )
    }

    return (
      <div className="w-full py-5">
        <div className="flex w-full mb-5" onClick={onClick}>
          <div
            className={classNames(
              "relative flex items-center w-full px-5",
              className,
              {
                hidden: collapsed
              }
            )}
          >
            <input
              type="text"
              placeholder={placeholder}
              ref={ref}
              value={value}
              onChange={onChange}
              onFocus={onFocus}
              readOnly={readOnly}
              className={classNames(
                "h-full block text-xs placeholder:text-[#9CA3AF] outline-none bg-inherit w-full  pr-10",
                {
                  "cursor-pointer": cursorBehavior === "pointer",
                  "cursor-not-allowed": cursorBehavior === "not-allowed"
                }
              )}
            />
          </div>

          {isSearchPage && (
            <button
              className="bg-[#4B5563] flex items-center justify-center px-3 md:hidden"
              aria-label="Filter"
              type="button"
              onClick={onFilterToggle}
            >
              <SearchFunnelIcon />
            </button>
          )}
        </div>
        <div className="px-5 w-full">
          <QueryToolbar
            initialAiMode={toolbarAiMode}
            onAiModeChange={(next) => setToolbarAiMode(next)}
            onSubmit={handleToolbarSubmit}
            onNavigateToAi={handleToolbarNavigateToAi}
            submitAriaLabel="submit search"
          />
        </div>
      </div>
    )
  }
)

export default SearchInputV3
